import React from 'react';
import styles from './tv-guide.module.scss';
import testIds from '@smart-tv/e2e/shared/variables';
import Typography from '@smart-tv/components/typography';

import {
  timeStringsOfAFullDay,
} from '@smart-tv/pages/tv-guide/utils/tv-guide-helpers';
import TvGuideDayViewContext from '../utils/tv-guide-day-view-context';


const TvGuideTimeline: React.FC = () => {
  const { scroll } = React.useContext(TvGuideDayViewContext);

  return (
    <div 
      className={styles['tv-guide-timeline']} 
      style={{ '--timeline-scroll': `-${scroll.left}px` } as React.CSSProperties}>
    
      {timeStringsOfAFullDay.map((timeSpan, index) => (
        <div className={styles['tv-guide-timeline__item']} key={index}>
          <Typography
            className={styles['tv-guide-timeline__item-text']}
            variant="caption"
            data-testid={testIds.tvGuide.timeline.item}
          >
            {timeSpan}
          </Typography>
        </div>
      ))}
    </div>
  );
};

export default React.memo(TvGuideTimeline);
